var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$route.meta.isAdmin)?_c('router-link',{class:{ active: !_vm.showNavbar },attrs:{"to":{ name: 'Account' },"id":"hamburger"}},[_c('span'),_c('span'),_c('span')]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }